var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "cms-gallery",
      class: [
        "cms-gallery--" + _vm.layoutMode,
        "cms-gallery--aspect-" + _vm.aspect,
      ],
      style: _vm.rootVars,
    },
    [
      _vm.images && _vm.images.length
        ? [
            _vm.layoutMode === "grid" || _vm.layoutMode === "masonry"
              ? _c(
                  "div",
                  { staticClass: "cms-gallery__items" },
                  _vm._l(_vm.images, function (img, idx) {
                    return _c(
                      "figure",
                      {
                        key: "gal-" + idx,
                        staticClass: "cms-gallery__item",
                        on: {
                          click: function ($event) {
                            _vm.lightboxEnabled && _vm.openLightbox(idx)
                          },
                        },
                      },
                      [
                        _c(
                          "img",
                          _vm._b(
                            {
                              staticClass: "cms-gallery__img",
                              attrs: { alt: img.alt || "" },
                            },
                            "img",
                            _vm.tileAttrs(img),
                            false
                          )
                        ),
                        _vm._v(" "),
                        _vm.captionsOn && (img.caption || _vm.creditFor(img))
                          ? _c(
                              "figcaption",
                              { staticClass: "cms-gallery__caption" },
                              [
                                img.caption
                                  ? _c("span", [_vm._v(_vm._s(img.caption))])
                                  : _vm._e(),
                                _vm.creditFor(img)
                                  ? _c(
                                      "small",
                                      { staticClass: "cms-gallery__credit" },
                                      [_vm._v(_vm._s(_vm.creditFor(img)))]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                )
              : _vm.layoutMode === "carousel"
              ? _c("div", { staticClass: "cms-gallery__carousel" }, [
                  _vm.images.length > 1
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "cms-gallery__arrow cms-gallery__arrow--prev",
                          attrs: { type: "button", "aria-label": "Previous" },
                          on: {
                            click: function ($event) {
                              return _vm.scrollBy(-1)
                            },
                          },
                        },
                        [_c("i", { staticClass: "fa fa-chevron-left" })]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { ref: "track", staticClass: "cms-gallery__track" },
                    _vm._l(_vm.images, function (img, idx) {
                      return _c(
                        "figure",
                        {
                          key: "gal-" + idx,
                          staticClass:
                            "cms-gallery__item cms-gallery__item--slide",
                          on: {
                            click: function ($event) {
                              _vm.lightboxEnabled && _vm.openLightbox(idx)
                            },
                          },
                        },
                        [
                          _c(
                            "img",
                            _vm._b(
                              {
                                staticClass: "cms-gallery__img",
                                attrs: { alt: img.alt || "" },
                              },
                              "img",
                              _vm.tileAttrs(img),
                              false
                            )
                          ),
                          _vm._v(" "),
                          _vm.captionsOn && (img.caption || _vm.creditFor(img))
                            ? _c(
                                "figcaption",
                                { staticClass: "cms-gallery__caption" },
                                [
                                  img.caption
                                    ? _c("span", [_vm._v(_vm._s(img.caption))])
                                    : _vm._e(),
                                  _vm.creditFor(img)
                                    ? _c(
                                        "small",
                                        { staticClass: "cms-gallery__credit" },
                                        [_vm._v(_vm._s(_vm.creditFor(img)))]
                                      )
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.images.length > 1
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "cms-gallery__arrow cms-gallery__arrow--next",
                          attrs: { type: "button", "aria-label": "Next" },
                          on: {
                            click: function ($event) {
                              return _vm.scrollBy(1)
                            },
                          },
                        },
                        [_c("i", { staticClass: "fa fa-chevron-right" })]
                      )
                    : _vm._e(),
                ])
              : _c(
                  "div",
                  {
                    staticClass: "cms-gallery__show",
                    on: {
                      "&touchstart": function ($event) {
                        return _vm.touchStart.apply(null, arguments)
                      },
                      "&touchend": function ($event) {
                        return _vm.touchEnd.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "figure",
                      {
                        staticClass:
                          "cms-gallery__item cms-gallery__item--show",
                        on: {
                          click: function ($event) {
                            _vm.lightboxEnabled && _vm.openLightbox(_vm.current)
                          },
                        },
                      },
                      [
                        _c(
                          "img",
                          _vm._b(
                            {
                              staticClass: "cms-gallery__img",
                              attrs: { alt: _vm.images[_vm.current].alt || "" },
                            },
                            "img",
                            _vm.slideAttrs(_vm.images[_vm.current]),
                            false
                          )
                        ),
                        _vm._v(" "),
                        _vm.captionsOn &&
                        (_vm.images[_vm.current].caption ||
                          _vm.creditFor(_vm.images[_vm.current]))
                          ? _c(
                              "figcaption",
                              {
                                staticClass:
                                  "cms-gallery__caption cms-gallery__caption--overlay",
                              },
                              [
                                _vm.images[_vm.current].caption
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.images[_vm.current].caption)
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm.creditFor(_vm.images[_vm.current])
                                  ? _c(
                                      "small",
                                      { staticClass: "cms-gallery__credit" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.creditFor(
                                              _vm.images[_vm.current]
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.images.length > 1
                      ? [
                          _c(
                            "button",
                            {
                              staticClass:
                                "cms-gallery__arrow cms-gallery__arrow--prev",
                              attrs: {
                                type: "button",
                                "aria-label": "Previous",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.step(-1)
                                },
                              },
                            },
                            [_c("i", { staticClass: "fa fa-chevron-left" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "cms-gallery__arrow cms-gallery__arrow--next",
                              attrs: { type: "button", "aria-label": "Next" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.step(1)
                                },
                              },
                            },
                            [_c("i", { staticClass: "fa fa-chevron-right" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "cms-gallery__dots" },
                            _vm._l(_vm.images, function (img, idx) {
                              return _c("button", {
                                key: "dot-" + idx,
                                staticClass: "cms-gallery__dot",
                                class: {
                                  "cms-gallery__dot--on": idx === _vm.current,
                                },
                                attrs: {
                                  type: "button",
                                  "aria-label": "Image " + (idx + 1),
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    _vm.current = idx
                                  },
                                },
                              })
                            }),
                            0
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
          ]
        : _c("div", { staticClass: "cms-gallery__empty" }, [
            _c("i", { staticClass: "fa fa-th" }),
            _vm._v(" "),
            _c("span", [_vm._v("No images added yet")]),
          ]),
      _vm._v(" "),
      _vm.lightboxIndex !== null
        ? _c(
            "div",
            {
              staticClass: "cms-gallery__lightbox",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  _vm.lightboxIndex = null
                },
              },
            },
            [
              _c(
                "button",
                {
                  staticClass: "cms-gallery__lightbox-close",
                  on: {
                    click: function ($event) {
                      _vm.lightboxIndex = null
                    },
                  },
                },
                [_c("i", { staticClass: "fa fa-times" })]
              ),
              _vm._v(" "),
              _vm.lightboxIndex > 0
                ? _c(
                    "button",
                    {
                      staticClass:
                        "cms-gallery__lightbox-nav cms-gallery__lightbox-nav--prev",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          _vm.lightboxIndex--
                        },
                      },
                    },
                    [_c("i", { staticClass: "fa fa-chevron-left" })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "img",
                _vm._b(
                  {
                    staticClass: "cms-gallery__lightbox-img",
                    attrs: { alt: _vm.images[_vm.lightboxIndex].alt || "" },
                  },
                  "img",
                  _vm.slideAttrs(_vm.images[_vm.lightboxIndex], true),
                  false
                )
              ),
              _vm._v(" "),
              _vm.lightboxIndex < _vm.images.length - 1
                ? _c(
                    "button",
                    {
                      staticClass:
                        "cms-gallery__lightbox-nav cms-gallery__lightbox-nav--next",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          _vm.lightboxIndex++
                        },
                      },
                    },
                    [_c("i", { staticClass: "fa fa-chevron-right" })]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }